import { bool, func } from 'prop-types';
import * as React from 'react';
import { AddLink, FormWrapper } from '../styles';

import {
  Overlay,
  ButtonWrapper,
  ConfirmModal,
  ConfirmButton,
  DeclineButton,
} from './styles';

const text = {
  title: {
    add: 'Är ni fler än en person som ska stå på hyreskontraktet?',
    remove: 'Har du råkat lägga till en extra bytespart av misstag?',
  },
  paragraph: {
    add:
      'Om ni är två personer som ska stå på det nya hyreskontraktet så måste båda fylla i sina uppgifter',
    remove:
      'Om det endast är en person som ska stå på det nya hyreskontraktet räcker det att den personen fyller i sina uppgifter.',
  },
  button: {
    add: '+ Klicka här för att lägga till en person till Bytesansökan',
    remove: '- Klicka här för att ta bort denna part från Bytesansökan',
  },
};

function AddMember({ addMember, removeMember, isAdd }) {
  const [showConfirmModal, setShowConfirmModal] = React.useState(false);
  const textType = isAdd ? 'add' : 'remove';

  const handleClick = () => {
    if (isAdd) {
      addMember();
    } else {
      setShowConfirmModal(true);
    }
  };

  const handleRemoveMember = () => {
    setShowConfirmModal(false);
    removeMember();
  };

  return (
    <FormWrapper>
      {showConfirmModal && (
        <React.Fragment>
          <Overlay onClick={() => setShowConfirmModal(false)} />
          <ConfirmModal>
            <div>Är du säker på att du vill ta bort denna bytespart?</div>
            <ButtonWrapper>
              <ConfirmButton onClick={handleRemoveMember}>Ja</ConfirmButton>
              <DeclineButton onClick={() => setShowConfirmModal(false)}>
                Nej
              </DeclineButton>
            </ButtonWrapper>
          </ConfirmModal>
        </React.Fragment>
      )}
      <h3>{text.title[textType]}</h3>
      <p>{text.paragraph[textType]}</p>
      <AddLink onClick={handleClick} red={!isAdd}>
        {text.button[textType]}
      </AddLink>
    </FormWrapper>
  );
}

AddMember.propTypes = {
  addMember: func.isRequired,
  isAdd: bool,
  removeMember: func.isRequired,
};

AddMember.defaultProps = {
  isAdd: false,
};

export default AddMember;



// WEBPACK FOOTER //
// ./src/views/Member/AddMember.js